import cn from 'classnames';
import { tags } from './utils/constants';
import styles from './styles.module.scss';

export default function WorksFilters({
  tag,
  onTagChange,
}) {
  return (
    <div className={styles.container}>
      {tags.map((item) => (
        <button
          type="button"
          className={cn(styles.tag, { [styles.active]: tag === item.slug })}
          onClick={() => onTagChange(item.slug)}
        >
          {item.title}
        </button>
      ))}
    </div>
  );
}
